<ws-modal-wrapper headerLabel="Choose Year"
                  (save)="save()"
                  [disableSave]="addingYear"
                  acceptLabel="OK"
                  (cancel)="cancel()"
                  [disableCancel]="addingYear">
    <div class="row mt-3">
        <div>
            @if (yearsToAdd) {
                <ws-select [(ngModel)]="yearToAdd"
                           [options]="yearsToAdd"
                           [canSearch]="false"
                           disabledProperty="disabled"
                           labelProperty="year"
                           valueProperty="year"
                           style="width: 200px;"
                           data-qa="contract-terms-add-year-select">
                </ws-select>
            }
            <div class="checkbox">
                <label>
                    <input type="checkbox" [(ngModel)]="rollForwardSiteOverrides" data-qa="contract-terms-add-year-roll-forward-site-overrides"> Roll Forward Site
                    Overrides
                </label>
            </div>
            @if (showFeeEscalator) {
                <div class="bg-warning" style="padding: 0.5em;">
                    NOTE: A {{ allData.feeEscalator * 100 | number: '1.2-2' }}% annual fixed fee escalator
                    will be applied to the following services:
                    <ul style="margin: 1em 0 0 0">
                        @for (serviceType of allData.escalatorServiceTypes; track serviceType) {
                            <li>
                                {{ getContractServiceTypename(serviceType) }}
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>
    </div>
</ws-modal-wrapper>
